<template>
  <v-layout wrap justify-start align-center align-content-center>
    <v-flex xs2 style="max-width:200px;">
      <v-select
        :items="minList"
        v-model="menuSetting.orderDescription.targetMileage.minMileage"
      />
    </v-flex>
    <v-flex xs1 style="text-align: center;">km</v-flex>
    <v-flex xs1 style="text-align: center;">〜</v-flex>
    <v-flex xs2 style="max-width:200px;">
      <v-select
        :items="maxList"
        v-model="menuSetting.orderDescription.targetMileage.maxMileage"
      />
    </v-flex>
    <v-flex xs1 style="text-align: center;">km</v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'CampaignModalPageAutomobileMileage',
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    minList() {
      const array = []
      array.push({
        text: 0,
        value: 0,
      })
      for (let i = 1; i <= 19; i++) {
        array.push({
          text: i + '万',
          value: i,
        })
      }
      array.push({
        text: 20 + '万超',
        value: 20,
      })
      return array
    },
    maxList() {
      const array = []
      for (let i = 1; i <= 19; i++) {
        array.push({
          text: i + '万',
          value: i,
        })
      }
      array.push({
        text: '上限なし',
        value: 20,
      })
      return array
    },
  },
  methods: {
    validate() {
      return true
    },
  },
}
</script>
